module.exports = __webpack_public_path__ + "assets/img/klm_en.fb07f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/klm_en.png
// module id = DZaF
// module chunks = 1